import analytics from "@idg-data-analytics-platform/analytics";

export function trackControlAccount(
  accountId?: string,
  customerNumber?: string,
  convercusAccountId?: string,
) {
  if (!accountId) {
    analytics({
      event: "account_set",
      team: "control",
      properties: {
        type: "shop",
        login_status: "unknown",
      },
    });
  } else {
    analytics({
      event: "account_set",
      team: "control",
      properties: {
        login_status: "logged_in",
        type: "shop",
        account_id: accountId,
        customer_number: customerNumber,
        loyalty_id: convercusAccountId,
        is_club_member: !!convercusAccountId,
      },
    });
  }
}
